export const commonConfig = {
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.5 : 1.0,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
};
